import { createGlobalStyle } from "styled-components"

export const CustomImageExtensionStyles = createGlobalStyle`
  .remirror-editor .remirror-image-resizable-wrapper {
    position: relative;
    overflow: visible;
    max-width: 100%;
    margin: 0;
    border-radius: 8px;
    border: 1px solid white;
    transition: border-color 0.2s ease;
  }

  .remirror-editor .remirror-image-resizable-wrapper:hover {
    outline: 2px solid #f0f0f0!important;
  }

  .remirror-editor .remirror-image-resizable-wrapper.ProseMirror-selectednode {
    outline: 2px solid #6567eb!important;
  }

  .remirror-image-resizable-wrapper img {
    display: block;
    width: 100%;
    height: auto; 
    min-width: 0;
    min-height: 0;
  }

  /* Estilos responsivos por tamaño */
  .remirror-image-resizable-wrapper.small {
    max-width: 300px;
  }

  .remirror-image-resizable-wrapper.medium {
    max-width: 500px;
  }

  .remirror-image-resizable-wrapper.large {
    max-width: 100%;
  }

  /* Responsive breakpoints */
  @media (max-width: 768px) {
    .remirror-image-resizable-wrapper {
      max-width: calc(100vw - 2rem);
      margin: 0.5rem auto;
    }

    .remirror-image-resizable-wrapper.small {
      max-width: 250px;
    }

    .remirror-image-resizable-wrapper.medium {
      max-width: 350px;
    }

    .remirror-image-resizable-wrapper.large {
      max-width: calc(100vw - 2rem);
    }

    .remirror-image-resizable-wrapper img {
      border-radius: 4px; /* Menos redondeado en mobile */
    }
  }

  

  .remirror-image-resizable-wrapper .resize-handle-single {
    width: 32px;
    height: 32px;
    position: absolute;
    bottom: 6px;
    right: 6px;
    background: white;
    border: 1px solid white;
    cursor: nwse-resize;
    border-radius: 50%;
    z-index: 10;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
    
    transition: all 0.2s ease;
    opacity: 0;
    transform: scale(0.8);
    
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .resize-handle-single::after {
    content: "⤡";
    font-size: 24px;
  }

  .remirror-image-resizable-wrapper:hover .resize-handle-single,
  .remirror-image-resizable-wrapper.ProseMirror-selectednode .resize-handle-single {
    background: white!important;
    opacity: 1!important;
  }

  /* Estilos para bloquear descarga de imágenes */
  .remirror-image-resizable-wrapper.download-blocked {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    pointer-events: auto;
  }

  .remirror-image-resizable-wrapper.download-blocked img.download-blocked {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    pointer-events: none;
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-drag: none;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: transparent;
  }

  /* Bloquear eventos de mouse para imágenes protegidas */
  .remirror-image-resizable-wrapper.download-blocked img.download-blocked:hover {
    cursor: default;
  }

  .remirror-image-resizable-wrapper.download-blocked img.download-blocked:active {
    cursor: default;
  }

  /* Mantener funcionalidad de resize para el owner */
  .remirror-image-resizable-wrapper.download-blocked .resize-handle-single {
    pointer-events: auto;
    cursor: nwse-resize;
  }

  /* Estilos específicos para modo preview (cuando no es owner) */
  .remirror-preview-container .remirror-image-resizable-wrapper.download-blocked img.download-blocked {
    pointer-events: none;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }



  .remirror-editor .remirror-image-resizable-wrapper:hover .resize-handle-single:hover {
    transform: scale(1)!important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15)!important;
  }


  /* Mobile: handle más grande para mejor usabilidad */
  @media (max-width: 768px) {
    .resize-handle-single {
      width: 20px;
      height: 20px;
      bottom: 2px;
      right: 2px;
    }

    .resize-handle-single::after {
      font-size: 14px;
    }
  }
  
  /* Estilo durante el redimensionamiento */
  .remirror-image-resizable-wrapper.resizing {
    user-select: none;
  }

  .remirror-image-resizable-wrapper.resizing img {
    pointer-events: none;
  }
  
  /* Asegurar que el editor no interfiera con la alineación */
  .remirror-editor .ProseMirror p {
    margin: 1em 0;
    clear: both;
  }

  /* Badge de progreso mejorado */
  .image-progress-badge {
    position: absolute;
    top: 8px;
    right: 8px;
    background: rgba(0, 0, 0, 0.8);
    color: #fff;
    padding: 6px 10px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 500;
    z-index: 15;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 60px;
    height: 28px;
    backdrop-filter: blur(4px);
    border: 1px solid rgba(255, 255, 255, 0.1);
  }

  .image-progress-badge img {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }

  /* Animación suave para cambios de tamaño */
  .remirror-image-resizable-wrapper:not(.resizing) img {
    transition: width 0.2s ease, height 0.2s ease;
  }

  /* Placeholder para imágenes que fallan */
  .remirror-image-resizable-wrapper.error {
    background: #f8f9fa;
    border: 2px dashed #dee2e6;
    min-height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6c757d;
    font-size: 14px;
    border-radius: 8px;
  }

  /* Mejoras de accesibilidad */
  .remirror-image-resizable-wrapper:focus-within {
    outline: 2px solid #7c3aed;
    outline-offset: 2px;
  }

  .resize-handle-single:focus {
    outline: 2px solid #7c3aed;
    outline-offset: 2px;
  }
`